module.exports = __webpack_public_path__ + "imgs/Norml.4af1aab009d3993747962b0ed1116f55.png";